<div class="container" [ngSwitch]="template.general.styleType">
  @if (timerConfiguration?.placement === TIMER_PLACEMENTS.INLINE_BAR) {
    <timer-preview variant="bar" [timerConfiguration]="timerConfiguration"></timer-preview>
  }
  <p class="title">
    <span [ngClass]="{ focused: !!mode }"></span>
    @if (timerConfiguration?.placement === TIMER_PLACEMENTS.BADGE) {
      <timer-preview variant="badge" [timerConfiguration]="timerConfiguration"></timer-preview>
    }
  </p>
  <div class="content" [ngStyle]="containerStyle" [ngClass]="{ focused: !!mode }">
    <div class="block-list" [ngClass]="[template.general.styleType]">
      <div [ngStyle]="blockStyle" *ngFor="let block of template.blocks">
        <div [ngSwitch]="block.type">
          <dynamic-block
            *ngSwitchCase="BlockType.DYNAMIC"
            [block]="block"
            [template]="template"
            [timerConfiguration]="timerConfiguration"></dynamic-block>
          <image-block *ngSwitchCase="BlockType.IMAGE" [block]="block" [template]="template"></image-block>
        </div>
      </div>
    </div>
  </div>
</div>
